// Configuration du module système ErrorNotification
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const ErrorNotificationConfig: ComponentMetadata = {
    name: 'ErrorNotification',
    displayName: 'Notifications Système',
    description: 'Affiche les notifications et erreurs du système (module système requis)',
    category: 'System',
    defaultParams: {},
    paramDefinitions: {},
    outsideGrid: true, // Toujours en dehors de la grille
    defaultEnabled: true
};

export default ErrorNotificationConfig;


